import {AbstractDictionaryViewModel} from "./abstract-dictionary.view-model";
import {CityApiModel} from "../../api/models/city.api-model";

export class CityViewModel extends AbstractDictionaryViewModel<CityApiModel> {
  public coordinates: number[];

  constructor(protected apiModel: CityApiModel) {
    super(apiModel);
    this.coordinates = apiModel.coordinates;
  }
}
